import React, { useId } from 'react';

interface RejectReasonProperties {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  label: string;
  placeholder: string;
  disabled?: boolean;
  valueRequired?: boolean;
  errorMessage?: string;
}

/**
 * Reusable Reject Reason textarea component.
 * @param {any} properties - Component properties
 * @returns {any} The component
 */
function RejectReasonField(properties: RejectReasonProperties): JSX.Element {
  const {
    value,
    onChange,
    error = false,
    label,
    placeholder,
    disabled = false,
    valueRequired = false,
    errorMessage = '',
  } = properties;
  const textareaId = useId();

  /**
   * Handles textarea value change.
   * @param {any} event - Change event
   */
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>): void => {
    onChange(event.target.value);
  };

  /**
   * Trims value on blur.
   * @param {any} event - Blur event
   */
  const handleBlur = (event: React.FocusEvent<HTMLTextAreaElement>): void => {
    onChange(event.target.value.trim());
  };

  return (
    <div className="reject-reason-field">
      <label
        htmlFor={textareaId}
        className={`reject-reason-field__label ${
          error ? 'reject-reason-field__label--error' : ''
        }`}>
        {label}
        {valueRequired && <span className="required">*</span>}
      </label>

      <textarea
        id={textareaId}
        className={`reject-reason-field__textarea ${
          error ? 'reject-reason-field__textarea--error' : ''
        } ${disabled ? 'view-mode' : ''}`}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={disabled}
      />

      {error && errorMessage && <span className="reject-reason-field__error">{errorMessage}</span>}
    </div>
  );
}

RejectReasonField.defaultProps = {
  error: null,
  disabled: null,
  valueRequired: false,
  errorMessage: '',
};
export default RejectReasonField;
